import { render, staticRenderFns } from "./ChannelDialog.vue?vue&type=template&id=23ba3cf7&"
import script from "./ChannelDialog.vue?vue&type=script&lang=ts&"
export * from "./ChannelDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports